import React from 'react'
import PulseLoader from 'react-spinners/PulseLoader'
import PropTypes from 'prop-types'

const Loading = ({ loading }) => {
  return (
    <div className='col-12 mb-2' style={{ textAlign: 'center' }}>
      <PulseLoader
        color={'#626365'}
        loading={loading}
        size={15}
        margin={4}
      />
    </div>
  )
}

Loading.propTypes = {
  loading: PropTypes.bool
}

export default Loading



// WEBPACK FOOTER //
// ./src/features/FocalPoint/Shared/Loading.js